import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This is to track the device categories from the backend.
 */
const INBOUND_COURIER_PROVIDER_LIST_KEY = 'inbound-courier-provider-list-query';

interface IInboundCourierProviderQuery {
  enabled: boolean;
}

/**
 * This hook fetches list of inbound items from mock APi.
 */
export const useFetchInboundCourierQuery = ({
  enabled,
}: IInboundCourierProviderQuery) => {
  const { data, isError, error, isPending, isFetching, refetch } =
    useQueryWithUserId({
      enabled,
      queryKey: [INBOUND_COURIER_PROVIDER_LIST_KEY],
      networkMode: 'always',
      queryFn: INBOUND_API.fetchInboundCourierProviderList,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    refetchCourierProviderList: refetch,
  };
};
